import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (benign browser warnings)
const resizeObserverErrDiv = document.createElement('div');
resizeObserverErrDiv.id = 'resize-observer-error-handler';
document.body.appendChild(resizeObserverErrDiv);

window.addEventListener('error', (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop') ||
    e.message.includes('ResizeObserver loop completed with undelivered notifications')
  )) {
    const resizeObserverErr = document.getElementById('resize-observer-error-handler');
    if (resizeObserverErr) {
      resizeObserverErr.textContent = '';
    }
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
